export default function () {
  const getApi = async (url, showToast = true) => {
    const nuxtApp = useNuxtApp()
    try {
      const response = await nuxtApp.$mainApi.get(url)
      return response.data
    } catch (error) {
      console.log(error?.response?.data?.message)
    }
  }

  const postApi = async (url, body = null, toast = false) => {
    const nuxtApp = useNuxtApp()
    try {
      const response = await nuxtApp.$mainApi.post(url, body)
      return response.data
    } catch (error) {
      console.log('error', error)
      if (toast) {
        throw error
      }
    }
  }

  const register = (mobileNumber) => {
    const body = { mobileNumber }

    return postApi('/auth/register', body, true)
  }

  const verify = (clientId, pinCode, utmSource, utmMedium, utmCampaign) => {
    const body = {
      clientId,
      pinCode,
      utmSource,
      utmMedium,
      utmCampaign,
    }

    return postApi('/auth/verify', body, true)
  }

  const refreshToken = (refreshToken) => {
    const body = { refreshToken }

    return postApi('/auth/refresh-token', body)
  }

  const referrer = (referrerId) => {
    const body = {
      referrerId,
    }

    return postApi('/user/referrer', body)
  }

  const reach = () => {
    return postApi('/game/reach', null, true)
  }

  const getUser = () => {
    return getApi('/user/profile')
  }

  const invitees = () => {
    return getApi('/user/invitees')
  }

  const getDiscountCode = () => {
    return getApi('/user/discount-codes')
  }

  const allRewards = () => {
    return getApi('/game/all-rewards')
  }

  return {
    register,
    verify,
    refreshToken,
    referrer,
    reach,
    invitees,
    getUser,
    getDiscountCode,
    allRewards,
  }
}
